import { useState, useEffect } from 'react'
import { Form, Field, FormElement } from "@progress/kendo-react-form";
import { FormTextArea, FormDropDownList, FormNumericTextBox, FormDropDownListFilter, FormDatePicker } from '../FormComponents';
import { getSitesDropdown } from '../../../data/siteData';
import { getClientsDropdown } from '../../../data/clientData';
import { dropDown } from '../../../data/interfaces'
import { requiredValidator } from '../Validators';

const AddProjectForm = (props: any) => {
   const [clientData, setClientData] = useState<dropDown[]>([]);
   const [clientDataOrig, setClientDataOrig] = useState<dropDown[]>([]);


   useEffect(() => {
      const fetchClientData = async () => {
         const clientData = await getClientsDropdown('');
         setClientData(clientData);
         setClientDataOrig(clientData);
      };

      fetchClientData();
   }, []);

   const handleSubmit = (dataItem: any) => {
      // alert(JSON.stringify(dataItem, null, 2));
      props.onProjectSubmit(dataItem);
   }



   //Search filters
   const searchClientDropdown = (searchTerm: string) => {
      const fetchClientData = async (search: string) => {
         await getClientsDropdown(search)
            .then(
               (result) => {
                  setClientData(result);
               }
            );
      };

      fetchClientData(searchTerm);
   }


   return (
      <>
         <Form
            onSubmit={handleSubmit}
            render={(formRenderProps) => (
               <FormElement style={{ padding: "1rem", marginBottom: "5rem" }}>
                  <fieldset className={"k-form-fieldset"}>
                     <div className='form__title__background' style={{ backgroundColor: "rgb(247, 205, 229)" }}>
                        <div className='form__subtitle' style={{ color: "rgb(76, 17, 54)", border: "1px solid rgb(35 66 91)" }}>
                           Add project details:
                           <button
                              className='form__reset__button'
                              onClick={formRenderProps.onFormReset}
                              style={{ margin: 0, backgroundColor: "rgb(35 66 91)", color: "white" }}>Clear fields
                           </button>
                        </div>
                     </div>

                     <Field
                        data={clientData}
                        originalData={clientDataOrig}
                        name={"clientName"}
                        component={FormDropDownListFilter}
                        label={"Client:"}
                        setData={setClientData}
                        searchDropdown={searchClientDropdown}
                        placeholder={"Choose a client:"}
                        validator={requiredValidator}
                     />

                     <Field
                        name={"description"}
                        component={FormTextArea}
                        label={"Description:"}
                        validator={requiredValidator}
                     />


                  </fieldset>
                  <div style={{ display: "flex", flexDirection: "row", bottom: 0, left: 0, width: "100%", padding: "1rem 2rem 1rem 2rem", position: "absolute", zIndex: "10000", backgroundColor: "white" }}>
                     <button
                        type={"submit"}
                        disabled={!formRenderProps.allowSubmit}
                        style={{ width: "100%", marginTop: "0.5rem", height: "3rem", backgroundColor: "rgb(174 199 65)", color: "rgb(71 83 21)", border: 0, borderRadius: "0.3rem" }}>
                        Add project
                     </button>
                  </div>
               </FormElement>
            )}
         />
      </>
   );
}

export default AddProjectForm;